// Lista Paesi ISO 3166-1 con denominazione in italiano.
// Usata per tabellare in combo il campo "Paese" degli indirizzi.
// Il valore memorizzato è il NOME (coerente con il default storico "Italia").
// L'Italia è in cima; gli altri Paesi seguono in ordine alfabetico.

export interface Paese {
  codice: string; // ISO 3166-1 alpha-2
  nome: string;   // denominazione in italiano
}

export const PAESI: Paese[] = [
  { codice: 'IT', nome: 'Italia' },
  { codice: 'AF', nome: 'Afghanistan' },
  { codice: 'AL', nome: 'Albania' },
  { codice: 'DZ', nome: 'Algeria' },
  { codice: 'AD', nome: 'Andorra' },
  { codice: 'AO', nome: 'Angola' },
  { codice: 'AG', nome: 'Antigua e Barbuda' },
  { codice: 'SA', nome: 'Arabia Saudita' },
  { codice: 'AR', nome: 'Argentina' },
  { codice: 'AM', nome: 'Armenia' },
  { codice: 'AU', nome: 'Australia' },
  { codice: 'AT', nome: 'Austria' },
  { codice: 'AZ', nome: 'Azerbaigian' },
  { codice: 'BS', nome: 'Bahamas' },
  { codice: 'BH', nome: 'Bahrein' },
  { codice: 'BD', nome: 'Bangladesh' },
  { codice: 'BB', nome: 'Barbados' },
  { codice: 'BE', nome: 'Belgio' },
  { codice: 'BZ', nome: 'Belize' },
  { codice: 'BJ', nome: 'Benin' },
  { codice: 'BT', nome: 'Bhutan' },
  { codice: 'BY', nome: 'Bielorussia' },
  { codice: 'BO', nome: 'Bolivia' },
  { codice: 'BA', nome: 'Bosnia ed Erzegovina' },
  { codice: 'BW', nome: 'Botswana' },
  { codice: 'BR', nome: 'Brasile' },
  { codice: 'BN', nome: 'Brunei' },
  { codice: 'BG', nome: 'Bulgaria' },
  { codice: 'BF', nome: 'Burkina Faso' },
  { codice: 'BI', nome: 'Burundi' },
  { codice: 'KH', nome: 'Cambogia' },
  { codice: 'CM', nome: 'Camerun' },
  { codice: 'CA', nome: 'Canada' },
  { codice: 'CV', nome: 'Capo Verde' },
  { codice: 'TD', nome: 'Ciad' },
  { codice: 'CL', nome: 'Cile' },
  { codice: 'CN', nome: 'Cina' },
  { codice: 'CY', nome: 'Cipro' },
  { codice: 'VA', nome: 'Città del Vaticano' },
  { codice: 'CO', nome: 'Colombia' },
  { codice: 'KM', nome: 'Comore' },
  { codice: 'CG', nome: 'Congo' },
  { codice: 'CD', nome: 'Congo (Rep. Dem.)' },
  { codice: 'KP', nome: 'Corea del Nord' },
  { codice: 'KR', nome: 'Corea del Sud' },
  { codice: 'CI', nome: 'Costa d\'Avorio' },
  { codice: 'CR', nome: 'Costa Rica' },
  { codice: 'HR', nome: 'Croazia' },
  { codice: 'CU', nome: 'Cuba' },
  { codice: 'DK', nome: 'Danimarca' },
  { codice: 'DM', nome: 'Dominica' },
  { codice: 'EC', nome: 'Ecuador' },
  { codice: 'EG', nome: 'Egitto' },
  { codice: 'SV', nome: 'El Salvador' },
  { codice: 'AE', nome: 'Emirati Arabi Uniti' },
  { codice: 'ER', nome: 'Eritrea' },
  { codice: 'EE', nome: 'Estonia' },
  { codice: 'ET', nome: 'Etiopia' },
  { codice: 'FJ', nome: 'Figi' },
  { codice: 'PH', nome: 'Filippine' },
  { codice: 'FI', nome: 'Finlandia' },
  { codice: 'FR', nome: 'Francia' },
  { codice: 'GA', nome: 'Gabon' },
  { codice: 'GM', nome: 'Gambia' },
  { codice: 'GE', nome: 'Georgia' },
  { codice: 'DE', nome: 'Germania' },
  { codice: 'GH', nome: 'Ghana' },
  { codice: 'JM', nome: 'Giamaica' },
  { codice: 'JP', nome: 'Giappone' },
  { codice: 'GI', nome: 'Gibilterra' },
  { codice: 'DJ', nome: 'Gibuti' },
  { codice: 'JO', nome: 'Giordania' },
  { codice: 'GR', nome: 'Grecia' },
  { codice: 'GD', nome: 'Grenada' },
  { codice: 'GL', nome: 'Groenlandia' },
  { codice: 'GT', nome: 'Guatemala' },
  { codice: 'GN', nome: 'Guinea' },
  { codice: 'GQ', nome: 'Guinea Equatoriale' },
  { codice: 'GW', nome: 'Guinea-Bissau' },
  { codice: 'GY', nome: 'Guyana' },
  { codice: 'HT', nome: 'Haiti' },
  { codice: 'HN', nome: 'Honduras' },
  { codice: 'IN', nome: 'India' },
  { codice: 'ID', nome: 'Indonesia' },
  { codice: 'IR', nome: 'Iran' },
  { codice: 'IQ', nome: 'Iraq' },
  { codice: 'IE', nome: 'Irlanda' },
  { codice: 'IS', nome: 'Islanda' },
  { codice: 'IL', nome: 'Israele' },
  { codice: 'KZ', nome: 'Kazakistan' },
  { codice: 'KE', nome: 'Kenya' },
  { codice: 'KG', nome: 'Kirghizistan' },
  { codice: 'KI', nome: 'Kiribati' },
  { codice: 'KW', nome: 'Kuwait' },
  { codice: 'LA', nome: 'Laos' },
  { codice: 'LS', nome: 'Lesotho' },
  { codice: 'LV', nome: 'Lettonia' },
  { codice: 'LB', nome: 'Libano' },
  { codice: 'LR', nome: 'Liberia' },
  { codice: 'LY', nome: 'Libia' },
  { codice: 'LI', nome: 'Liechtenstein' },
  { codice: 'LT', nome: 'Lituania' },
  { codice: 'LU', nome: 'Lussemburgo' },
  { codice: 'MK', nome: 'Macedonia del Nord' },
  { codice: 'MG', nome: 'Madagascar' },
  { codice: 'MW', nome: 'Malawi' },
  { codice: 'MY', nome: 'Malaysia' },
  { codice: 'MV', nome: 'Maldive' },
  { codice: 'ML', nome: 'Mali' },
  { codice: 'MT', nome: 'Malta' },
  { codice: 'MA', nome: 'Marocco' },
  { codice: 'MH', nome: 'Marshall (Isole)' },
  { codice: 'MR', nome: 'Mauritania' },
  { codice: 'MU', nome: 'Mauritius' },
  { codice: 'MX', nome: 'Messico' },
  { codice: 'FM', nome: 'Micronesia' },
  { codice: 'MD', nome: 'Moldavia' },
  { codice: 'MC', nome: 'Monaco' },
  { codice: 'MN', nome: 'Mongolia' },
  { codice: 'ME', nome: 'Montenegro' },
  { codice: 'MZ', nome: 'Mozambico' },
  { codice: 'MM', nome: 'Myanmar (Birmania)' },
  { codice: 'NA', nome: 'Namibia' },
  { codice: 'NR', nome: 'Nauru' },
  { codice: 'NP', nome: 'Nepal' },
  { codice: 'NI', nome: 'Nicaragua' },
  { codice: 'NE', nome: 'Niger' },
  { codice: 'NG', nome: 'Nigeria' },
  { codice: 'NO', nome: 'Norvegia' },
  { codice: 'NZ', nome: 'Nuova Zelanda' },
  { codice: 'OM', nome: 'Oman' },
  { codice: 'NL', nome: 'Paesi Bassi' },
  { codice: 'PK', nome: 'Pakistan' },
  { codice: 'PW', nome: 'Palau' },
  { codice: 'PS', nome: 'Palestina' },
  { codice: 'PA', nome: 'Panama' },
  { codice: 'PG', nome: 'Papua Nuova Guinea' },
  { codice: 'PY', nome: 'Paraguay' },
  { codice: 'PE', nome: 'Perù' },
  { codice: 'PL', nome: 'Polonia' },
  { codice: 'PT', nome: 'Portogallo' },
  { codice: 'QA', nome: 'Qatar' },
  { codice: 'GB', nome: 'Regno Unito' },
  { codice: 'CZ', nome: 'Repubblica Ceca' },
  { codice: 'CF', nome: 'Repubblica Centrafricana' },
  { codice: 'DO', nome: 'Repubblica Dominicana' },
  { codice: 'RO', nome: 'Romania' },
  { codice: 'RW', nome: 'Ruanda' },
  { codice: 'RU', nome: 'Russia' },
  { codice: 'KN', nome: 'Saint Kitts e Nevis' },
  { codice: 'LC', nome: 'Saint Lucia' },
  { codice: 'VC', nome: 'Saint Vincent e Grenadine' },
  { codice: 'WS', nome: 'Samoa' },
  { codice: 'SM', nome: 'San Marino' },
  { codice: 'ST', nome: 'Sao Tomé e Principe' },
  { codice: 'SN', nome: 'Senegal' },
  { codice: 'RS', nome: 'Serbia' },
  { codice: 'SC', nome: 'Seychelles' },
  { codice: 'SL', nome: 'Sierra Leone' },
  { codice: 'SG', nome: 'Singapore' },
  { codice: 'SY', nome: 'Siria' },
  { codice: 'SK', nome: 'Slovacchia' },
  { codice: 'SI', nome: 'Slovenia' },
  { codice: 'SO', nome: 'Somalia' },
  { codice: 'ES', nome: 'Spagna' },
  { codice: 'LK', nome: 'Sri Lanka' },
  { codice: 'US', nome: 'Stati Uniti d\'America' },
  { codice: 'ZA', nome: 'Sudafrica' },
  { codice: 'SD', nome: 'Sudan' },
  { codice: 'SS', nome: 'Sudan del Sud' },
  { codice: 'SR', nome: 'Suriname' },
  { codice: 'SE', nome: 'Svezia' },
  { codice: 'CH', nome: 'Svizzera' },
  { codice: 'SZ', nome: 'Swaziland (Eswatini)' },
  { codice: 'TJ', nome: 'Tagikistan' },
  { codice: 'TW', nome: 'Taiwan' },
  { codice: 'TZ', nome: 'Tanzania' },
  { codice: 'TH', nome: 'Thailandia' },
  { codice: 'TL', nome: 'Timor Est' },
  { codice: 'TG', nome: 'Togo' },
  { codice: 'TO', nome: 'Tonga' },
  { codice: 'TT', nome: 'Trinidad e Tobago' },
  { codice: 'TN', nome: 'Tunisia' },
  { codice: 'TR', nome: 'Turchia' },
  { codice: 'TM', nome: 'Turkmenistan' },
  { codice: 'TV', nome: 'Tuvalu' },
  { codice: 'UA', nome: 'Ucraina' },
  { codice: 'UG', nome: 'Uganda' },
  { codice: 'HU', nome: 'Ungheria' },
  { codice: 'UY', nome: 'Uruguay' },
  { codice: 'UZ', nome: 'Uzbekistan' },
  { codice: 'VU', nome: 'Vanuatu' },
  { codice: 'VE', nome: 'Venezuela' },
  { codice: 'VN', nome: 'Vietnam' },
  { codice: 'YE', nome: 'Yemen' },
  { codice: 'ZM', nome: 'Zambia' },
  { codice: 'ZW', nome: 'Zimbabwe' },
];

// Nome del Paese considerato "nazionale" (non estero).
export const PAESE_ITALIA = 'Italia';

// True se il Paese indicato è estero (qualsiasi valore diverso da Italia, con
// normalizzazione difensiva per i dati storici a testo libero: "IT", "Italy"…).
export function isEstero(paese?: string | null): boolean {
  if (!paese) return false; // assente → trattato come nazionale (default storico)
  const p = paese.trim().toLowerCase();
  return !(p === 'italia' || p === 'it' || p === 'italy');
}
